import { render, staticRenderFns } from "./temporaryWorkFeedbackForm.vue?vue&type=template&id=671eb2de&"
import script from "./temporaryWorkFeedbackForm.vue?vue&type=script&lang=js&"
export * from "./temporaryWorkFeedbackForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports